import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchCFRLogsURLStart } from "store/actions";

import {
  encodeHandler,
  epocToDate,
  formatBytes,
  formatTimeDuration
} from "utils";
import { CONTENT, TOOLTIPS, CLIENT_ERROR_MSGS } from "consts";
import Tooltip from "App/common/ui/Tooltip";
import { ReactComponent as LogsSafe } from "assets/images/app_svg/logs_safe.svg";
import { ReactComponent as LogsFail } from "assets/images/app_svg/logs_fail.svg";
import { ReactComponent as LogsStopped } from "assets/images/app_svg/logs_stopped.svg";

function RestoreLogs(props) {
  function fetchCFRLogs(url, index) {
    props.fetchCFRLogsURLStart(url, index);
  }

  function Title() {
    if (props.data.mode === props.enums.RestoreType.FILE_RESTORE_UI) {
      return (
        <React.Fragment>
          {(props.data.status === props.enums.RestoreJobStatus.CLIENT_CANCELLED
            ? CONTENT.appLogs.restore.fileRestore.ui.stopped
            : props.data.status === props.enums.RestoreJobStatus.SUCCESS
            ? CONTENT.appLogs.restore.fileRestore.ui.success
            : CONTENT.appLogs.restore.fileRestore.ui.failure) +
            " - " +
            props.data.url.split("/")[props.data.url.split("/").length - 1]}
          <span>{" (" + formatBytes(props.data.size) + ")"}</span>
        </React.Fragment>
      );
    } else if (
      props.data.mode === props.enums.RestoreType.FILE_RESTORE_CLIENT
    ) {
      return (
        <React.Fragment>
          {props.data.status === props.enums.RestoreJobStatus.CLIENT_CANCELLED
            ? CONTENT.appLogs.restore.fileRestore.client.stopped
            : props.data.status === props.enums.RestoreJobStatus.SUCCESS
            ? CONTENT.appLogs.restore.fileRestore.client.success
                .originalLocation
            : CONTENT.appLogs.restore.fileRestore.client.failure}
          <span>
            {" (" + formatBytes(props.data.size) + ")"} -{" "}
            {props.data.totalFiles} Files
          </span>
        </React.Fragment>
      );
    } else if (
      props.data.mode === props.enums.RestoreType.FILE_RESTORE_CUSTOM
    ) {
      return (
        <React.Fragment>
          {props.data.status === props.enums.RestoreJobStatus.CLIENT_CANCELLED
            ? CONTENT.appLogs.restore.fileRestore.client.stopped
            : props.data.status === props.enums.RestoreJobStatus.SUCCESS
            ? CONTENT.appLogs.restore.fileRestore.client.success.customLocation
            : CONTENT.appLogs.restore.fileRestore.client.failure}
          <span>
            {" (" + formatBytes(props.data.size) + ")"} -{" "}
            {props.data.totalFiles} Files
          </span>
        </React.Fragment>
      );
    } else if (props.data.mode === props.enums.RestoreType.VOLUME_RESTORE) {
      return (
        <React.Fragment>
          {props.data.status === props.enums.RestoreJobStatus.CLIENT_CANCELLED
            ? CONTENT.appLogs.restore.volumeRestore.stopped
            : props.data.status === props.enums.RestoreJobStatus.SUCCESS
            ? CONTENT.appLogs.restore.volumeRestore.success.originalLocation
            : CONTENT.appLogs.restore.volumeRestore.failure}
          <span>{" (" + formatBytes(props.data.size) + ")"}</span>
        </React.Fragment>
      );
    } else if (props.data.mode === props.enums.RestoreType.DISK_RESTORE) {
      return (
        <React.Fragment>
          {props.data.status === props.enums.RestoreJobStatus.CLIENT_CANCELLED
            ? CONTENT.appLogs.restore.imageRestore.stopped
            : props.data.status === props.enums.RestoreJobStatus.SUCCESS
            ? CONTENT.appLogs.restore.imageRestore.success.originalLocation
            : CONTENT.appLogs.restore.imageRestore.failure}
          <span>{" (" + formatBytes(props.data.size) + ")"}</span>
        </React.Fragment>
      );
    } else if (props.data.mode === props.enums.RestoreType.VIRTUALIZATION) {
      return (
        <React.Fragment>
          <span>({formatBytes(props.data.size)})</span>
        </React.Fragment>
      );
    }
  }

  function Detials() {
    return (
      <div className="logs_item_details">
        <span>{epocToDate(props.timeStamp, "MMM d yyyy, hh:mm:ss")}</span>
        <span> | </span>
        <span>Duration: {formatTimeDuration(props.data.duration)}</span>
        <span> | </span>
        <span>
          Recovery version:{" "}
          {epocToDate(props.data.recoveryPoint, "MM-dd-yyyy, hh:mm:ss")}
        </span>
      </div>
    );
  }
  function FailureReason() {
    const errorCode = props.enums.ErrorCodes.props[props.data.errorCode]
      ? props.enums.ErrorCodes.props[props.data.errorCode].key
      : null;
    return errorCode && CLIENT_ERROR_MSGS[errorCode] ? (
      <div class="logs_item_msg_list error_msg">
        <p>{CLIENT_ERROR_MSGS[errorCode]}</p>
      </div>
    ) : (
      <></>
    );
  }
  return (
    <div
      className={[
        "logs_item logs_",
        props.data.status === props.enums.RestoreJobStatus.SUCCESS
          ? "safe"
          : props.data.status === props.enums.RestoreJobStatus.FAILURE
          ? "failed"
          : "stopped"
      ].join("")}
    >
      <div className="logs_item_title">
        {props.data.status === props.enums.RestoreJobStatus.SUCCESS ? (
          <LogsSafe />
        ) : props.data.status ===
          props.enums.RestoreJobStatus.CLIENT_CANCELLED ? (
          <LogsStopped />
        ) : (
          <LogsFail />
        )}
        <p>
          <Title />
        </p>
      </div>
      <Detials />
      {props.data.url ? (
        props.loading ? (
          <Tooltip {...TOOLTIPS.logs.downloading}>
            <div
              className="item_loader"
              data-toggle="tooltip"
              data-original-title="Loading"
            >
              <div className="log_file_loader" title="Loading" />
            </div>
          </Tooltip>
        ) : (
          <Tooltip {...TOOLTIPS.logs.download}>
            <span
              className="icon"
              data-toggle="tooltip"
              data-original-title="Download"
              onClick={() =>
                fetchCFRLogs(
                  encodeHandler(
                    props.data.url.replace("/etc/imirror/Logs", "restoreLogs")
                  ),
                  props.index
                )
              }
            ></span>
          </Tooltip>
        )
      ) : (
        ""
      )}
      {props.data.status === props.enums.RestoreStatus.FAILURE && (
        <>
          <FailureReason />
        </>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    logs: state.appLogs
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCFRLogsURLStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RestoreLogs);
